<div class="surface-ground px-4 py-5 md:px-6 lg:px-8 w-full add-institute-container">
    <p-toast></p-toast>

    <!-- Centered loader while loading form data (edit mode) -->
    <div *ngIf="loadingFormData" class="form-data-loader-overlay">
        <div class="form-data-loader-content">
            <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
            <p class="loader-label mt-3 m-0 text-600">Loading institute details...</p>
        </div>
    </div>

    <div
        class="card bg-white border-round-xl p-4 mb-4 flex flex-column md:flex-row align-items-center md:align-items-center justify-content-between gap-3">
        <div class="flex align-items-center w-full md:w-auto">
            <button pButton icon="pi pi-arrow-left" class="p-button-rounded back-arrow-btn mr-3"
                (click)="goBack()"></button>
            <div>
                <h1 class="text-3xl font-bold text-900 m-0">{{ isAddModeSession ? 'Add Institute' : 'Update Institute'
                    }}</h1>
                <p class="text-600 m-0 mt-1">{{ isAddModeSession ? 'Fill in the institute details below' : 'Update the
                    institute details below' }}</p>
            </div>
        </div>
        <div class="flex justify-content-start md:justify-content-end w-full md:w-auto mt-2 md:mt-0">
            <button pButton
                [label]="activeIndex === 4 ? (isAddModeSession ? 'Finish & Save' : 'Finish & Update') : (isAddModeSession ? 'Save & Next' : 'Update & Next')"
                icon="pi pi-save" class="custom-save-btn" [loading]="loading" (click)="save()"></button>
        </div>
    </div>

    <div>
        <p-tabView styleClass="custom-tabs" [(activeIndex)]="activeIndex">
            <p-tabPanel header="Basic Info">
                <app-basic-info #basicInfoTab [form]="basicInfoForm" [instituteId]="instituteId"
                    [isEditMode]="isEditMode" [branchCampusesData]="branchCampusesData" [alumniData]="alumniData"
                    (onSaveSuccess)="handleSaveSuccess($event)" (onSaveError)="handleSaveError($event)">
                </app-basic-info>
            </p-tabPanel>
            <p-tabPanel header="Rankings" [disabled]="activeIndex < 1">
                <app-rankings #rankingsTab [form]="rankingsForm" [instituteId]="instituteId" [isEditMode]="isEditMode"
                    (onSaveSuccess)="handleSaveSuccess($event)" (onSaveError)="handleSaveError($event)">
                </app-rankings>
            </p-tabPanel>
            <p-tabPanel header="Undergraduate" [disabled]="activeIndex < 2">
                <app-undergraduate #undergraduateTab [form]="undergraduateForm" [instituteId]="instituteId"
                    [isEditMode]="isEditMode" (onSaveSuccess)="handleSaveSuccess($event)"
                    (onSaveError)="handleSaveError($event)">
                </app-undergraduate>
            </p-tabPanel>
            <p-tabPanel header="Masters/Doctoral" [disabled]="activeIndex < 3">
                <app-masters-doctoral #mastersDoctoralTab [form]="mastersDoctoralForm" [instituteId]="instituteId"
                    [isEditMode]="isEditMode" (onSaveSuccess)="handleSaveSuccess($event)"
                    (onSaveError)="handleSaveError($event)">
                </app-masters-doctoral>
            </p-tabPanel>
            <p-tabPanel header="Courses" [disabled]="activeIndex < 4">
                <app-courses #coursesTab [courses]="coursesArray" [instituteId]="instituteId" [isEditMode]="isEditMode"
                    (onSaveSuccess)="handleSaveSuccess($event)" (onSaveError)="handleSaveError($event)">
                </app-courses>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>